import { ThunkDispatch } from 'redux-thunk';
import { GlobalState } from '../../../store/reducers';
import getSupportTickets, { Ticket } from '../../../api/getSupportTickets';
import { Fragment, PureComponent, ReactNode } from 'react';
import { connect } from 'react-redux';
import { getDoc } from '../../../store/idbHandler';
import { captureError, captureErrorString } from '../../../pages/captureError';
import { track } from '../../../tracking';
import { hideDialog } from '../../../store/actions/prescriptionPad';
import { openCrispChat } from '../../../pages/utils';
import getSupportTicketActions, { Action } from '../../../api/getSupportTicketActions';
import { isForProd } from '../../../api/constants';
import sendToSlack from '../../../api/sendToSlack';
import { Button, notification } from 'antd';
import { AnimatePresence } from 'framer-motion';
import { SlideFromRightWrapper } from '../SlideFromRightWrapper';
import Hotkeys from 'react-hot-keys';
import moment from 'moment';
import FeedbackPopover from './FeedbackPopover';
import { Actions } from '../../../store/actions';

const colorObject: {
    [k: string]: {
        color: string;
        background: string;
        icon: JSX.Element;
    };
} = {
    Pending: {
        color: '#8E6807',
        background: '#FDF7E7',
        icon: (
            <svg className="w-14 h-14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 0.625C10.5801 0.625 13.5 3.54492 13.5 7.125C13.5 10.7305 10.5801 13.625 7 13.625C3.39453 13.625 0.5 10.7305 0.5 7.125C0.5 3.54492 3.39453 0.625 7 0.625ZM7 12.4062C9.89453 12.4062 12.2812 10.0449 12.2812 7.125C12.2812 4.23047 9.89453 1.84375 7 1.84375C4.08008 1.84375 1.71875 4.23047 1.71875 7.125C1.71875 10.0449 4.08008 12.4062 7 12.4062ZM9.58984 7.9375C9.86914 8.08984 9.9707 8.4707 9.79297 8.75C9.69141 8.95312 9.48828 9.05469 9.28516 9.05469C9.1582 9.05469 9.05664 9.0293 8.98047 8.97852L6.69531 7.6582C6.49219 7.55664 6.39062 7.35352 6.39062 7.125V3.67188C6.39062 3.3418 6.64453 3.0625 7 3.0625C7.33008 3.0625 7.60938 3.3418 7.60938 3.67188V6.79492L9.58984 7.9375Z"
                    fill="#8E6807"
                />
            </svg>
        ),
    },
    'In Progress': {
        color: '#215FFF',
        background: '#E9EFFF',
        icon: (
            <svg className="w-10 h-14" viewBox="0 0 10 14" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M0.734375 0.625H9.26562C9.5957 0.625 9.875 0.904297 9.875 1.23438C9.875 1.58984 9.5957 1.84375 9.26562 1.84375H9.0625V2.32617C9.0625 3.36719 8.65625 4.33203 7.91992 5.06836L5.83789 7.125L7.91992 9.20703C8.65625 9.91797 9.0625 10.9082 9.0625 11.9238V12.4062H9.26562C9.5957 12.4062 9.875 12.6855 9.875 13.0156C9.875 13.3711 9.5957 13.625 9.26562 13.625H0.734375C0.378906 13.625 0.125 13.3711 0.125 13.0156C0.125 12.6855 0.378906 12.4062 0.734375 12.4062H0.9375V11.9238C0.9375 10.9082 1.34375 9.91797 2.05469 9.20703L4.13672 7.125L2.05469 5.06836C1.34375 4.33203 0.9375 3.36719 0.9375 2.32617V1.84375H0.734375C0.378906 1.84375 0.125 1.58984 0.125 1.23438C0.125 0.904297 0.378906 0.625 0.734375 0.625ZM5 7.98828L2.91797 10.0703C2.43555 10.5527 2.15625 11.2383 2.15625 11.9238V12.4062H7.84375V11.9238C7.84375 11.2383 7.56445 10.5527 7.05664 10.0703L5 7.98828ZM5 6.26172V6.28711L7.05664 4.20508C7.56445 3.69727 7.84375 3.03711 7.84375 2.32617V1.84375H2.15625V2.32617C2.15625 3.03711 2.43555 3.69727 2.91797 4.20508L5 6.26172Z"
                    fill="#215FFF"
                />
            </svg>
        ),
    },
    Resolved: {
        color: '#19A66A',
        background: '#E8F6F0',
        icon: (
            <svg className="w-14 h-14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 1.84375C5.0957 1.84375 3.36914 2.85938 2.4043 4.48438C1.46484 6.13477 1.46484 8.14062 2.4043 9.76562C3.36914 11.416 5.0957 12.4062 7 12.4062C8.87891 12.4062 10.6055 11.416 11.5703 9.76562C12.5098 8.14062 12.5098 6.13477 11.5703 4.48438C10.6055 2.85938 8.87891 1.84375 7 1.84375ZM7 13.625C4.66406 13.625 2.53125 12.4062 1.36328 10.375C0.195312 8.36914 0.195312 5.90625 1.36328 3.875C2.53125 1.86914 4.66406 0.625 7 0.625C9.31055 0.625 11.4434 1.86914 12.6113 3.875C13.7793 5.90625 13.7793 8.36914 12.6113 10.375C11.4434 12.4062 9.31055 13.625 7 13.625ZM9.86914 5.93164L6.61914 9.18164C6.36523 9.43555 5.98438 9.43555 5.75586 9.18164L4.13086 7.55664C3.87695 7.32812 3.87695 6.94727 4.13086 6.71875C4.35938 6.46484 4.74023 6.46484 4.99414 6.71875L6.1875 7.91211L9.00586 5.09375C9.23438 4.83984 9.61523 4.83984 9.86914 5.09375C10.0977 5.32227 10.0977 5.70312 9.86914 5.93164Z"
                    fill="#19A66A"
                />
            </svg>
        ),
    },
};

type Props = {
    dispatch: ThunkDispatch<GlobalState, null, Actions>;
};

type State = {
    isFetchingTickets: boolean;
    tickets: Ticket[];
    statusFiltersSet: Set<string>;
    lastUpdated: string;
    activeTicket?: Ticket;
    isFetchingActions: boolean;
    actions: Action[];
    description: string;
};

class AllSupportTickets extends PureComponent<Props, State> {
    initialState: State = {
        isFetchingTickets: true,
        tickets: [],
        statusFiltersSet: new Set(),
        lastUpdated: new Date().toISOString(),
        activeTicket: undefined,
        isFetchingActions: true,
        actions: [],
        description: '',
    };
    activeTicketInitialState = { isFetchingActions: true, actions: [], description: '' };
    state = this.initialState;

    docProfile = getDoc();

    componentDidMount() {
        const { fetchTickets } = this;
        fetchTickets();
    }

    fetchTickets = async (): Promise<void> => {
        try {
            const { success, tickets, error } = await getSupportTickets();
            if (success) {
                this.setState({
                    tickets,
                    lastUpdated: new Date().toISOString(),
                });
            } else if (error) {
                captureErrorString(error);
                track('ERROR', {
                    on: 'getSupportTickets',
                    error,
                });
            }
        } catch (error) {
            captureError(error as Error);
            track('ERROR', {
                on: 'getSupportTickets',
                error: (error as Error).message,
            });
        } finally {
            this.setState({ isFetchingTickets: false });
        }
    };

    closeMe = () => {
        const { dispatch } = this.props;
        dispatch(hideDialog('support-tickets'));
    };

    getStatusFilters = () => {
        const { tickets } = this.state;
        const statusFilters = [];
        const obj: { [k: string]: number } = {};
        tickets.forEach((i) => {
            const key = i.status;
            if (obj[key]) obj[key] += 1;
            else obj[key] = 1;
        });
        for (const key in obj) {
            statusFilters.push({ status: key, label: key, count: obj[key] });
        }
        return statusFilters.sort((a, b) => b.count - a.count);
    };

    toggleStatusFilters = (status: string): void => {
        const { statusFiltersSet } = this.state;
        if (statusFiltersSet.has(status)) statusFiltersSet.delete(status);
        else statusFiltersSet.add(status);
        this.setState({
            statusFiltersSet: new Set([...statusFiltersSet]),
        });
    };

    clearFilters = () => {
        this.setState({
            statusFiltersSet: new Set(),
        });
    };

    onRaiseNewTicket = () => {
        openCrispChat(
            'RAISE_NEW_TICKET',
            {
                from: 'My Support Tickets [raise new ticket]',
            },
            `I want to raise a ticket`,
        );
    };

    onConnectWithSuccessManager = () => {
        openCrispChat(
            'RAISE_NEW_ISSUE',
            {
                from: 'My Support Tickets [connect with success manager]',
            },
            `Hello Success Manager`,
        );
    };

    onRefreshTickets = () => {
        const { fetchTickets, initialState } = this;
        this.setState({ ...initialState, statusFiltersSet: new Set() }, fetchTickets);
    };

    toggleActiveTicket = (ticket?: Ticket) => {
        const { fetchActions, activeTicketInitialState } = this;
        this.setState({ activeTicket: ticket });
        if (ticket) {
            fetchActions(ticket.id);
            const { name, url } = ticket;
            track('VIEW_SUPPORT_TICKET_DETAILS', { name, url });
        } else {
            this.setState(activeTicketInitialState);
        }
    };

    onRequestUpdate = () => {
        const { activeTicket } = this.state;
        const { docProfile } = this;
        const docId = docProfile?._id || '';
        const docName = [docProfile?.profile.personal.name.f, docProfile?.profile.personal.name.l]
            .filter(Boolean)
            .join(' ');
        const { name, url } = activeTicket || {};
        openCrispChat(
            'REQUEST_UPDATE',
            {
                from: 'My Support Tickets',
                name,
                url,
            },
            `I want update for this ticket => ${name}`,
        );
        sendToSlack({
            key: 'support-tickets-feedback',
            payload: [
                {
                    blocks: [
                        {
                            type: 'section',
                            text: {
                                type: 'mrkdwn',
                                text: `[${
                                    isForProd ? 'prod' : 'dev'
                                }] [${docId} | Dr. ${docName}] => I want update for this ticket ${
                                    activeTicket?.url
                                }`,
                            },
                        },
                    ],
                },
            ],
        });
    };

    fetchActions = async (id: string): Promise<void> => {
        try {
            const { success, actions, description, error } = await getSupportTicketActions(id);
            if (success) {
                this.setState({
                    actions: actions,
                    description: description,
                });
            } else if (error) {
                captureErrorString(error);
                track('ERROR', {
                    on: 'getSupportTicketActions',
                    error,
                });
            }
        } catch (error) {
            captureError(error as Error);
            track('ERROR', {
                on: 'getSupportTicketActions',
                error: (error as Error).message,
            });
        } finally {
            this.setState({ isFetchingActions: false });
        }
    };

    onRefreshActions = () => {
        const { activeTicket } = this.state;
        const { fetchActions, activeTicketInitialState } = this;
        this.setState(activeTicketInitialState);
        fetchActions(activeTicket?.id || '');
    };

    onFeedback = (type: string, reason?: string) => {
        const { docProfile } = this;
        const docId = docProfile?._id || '';
        const docName = [docProfile?.profile.personal.name.f, docProfile?.profile.personal.name.l]
            .filter(Boolean)
            .join(' ');
        let text = '';
        if (type === 'positive') {
            text = `🥳 Positive feedback received. [${isForProd ? 'prod' : 'dev'}]`;
        } else {
            text = `🚨 Negative feedback received. [${isForProd ? 'prod' : 'dev'}]`;
        }
        text += `\nDoctor: ${docName} | ${docId}`;
        if (reason?.trim()?.length) {
            text += `\nRemarks: ${reason}`;
        }
        sendToSlack({
            key: 'support-tickets-feedback',
            payload: [
                {
                    blocks: [
                        {
                            type: 'section',
                            text: {
                                type: 'mrkdwn',
                                text: text,
                            },
                        },
                    ],
                },
            ],
        });
        notification.success({
            message: 'Thanks for your feedback 👍.',
            duration: 5,
        });
        track('SUPPORT_TICKETS_FEEDBACK', {
            type,
            reason: reason || '-',
        });
    };

    render(): ReactNode {
        const {
            statusFiltersSet,
            activeTicket,
            lastUpdated,
            isFetchingTickets,
            isFetchingActions,
            actions,
            description,
        } = this.state;
        let { tickets } = this.state;
        const {
            getStatusFilters,
            closeMe,
            onRefreshTickets,
            toggleStatusFilters,
            clearFilters,
            toggleActiveTicket,
            onConnectWithSuccessManager,
            onRaiseNewTicket,
            onFeedback,
            onRefreshActions,
            onRequestUpdate,
        } = this;

        if (statusFiltersSet.size > 0) {
            tickets = tickets.filter((i) => statusFiltersSet.has(i.status));
        }
        const statusFilters = getStatusFilters();
        const { color, background, icon } = colorObject[activeTicket?.status || ''] || {};

        tickets = tickets.sort((a, b) =>
            new Date(a.created_at) < new Date(b.created_at) ? 1 : -1,
        );

        return (
            <AnimatePresence>
                <Hotkeys keyName="esc" onKeyDown={closeMe}>
                    <SlideFromRightWrapper closeMe={closeMe} cssClass="w-592">
                        {activeTicket ? (
                            <div
                                className="w-full h-full flex flex-col bg-darwin-neutrals-50 overflow-hidden"
                                style={{ color: '#1A1A1A' }}
                            >
                                <div className="px-16 py-12 flex items-center justify-between space-x-8 bg-white border-b border-darwin-neutral_new-200">
                                    <div className="flex items-center space-x-8">
                                        <button onClick={() => toggleActiveTicket()}>
                                            <svg
                                                className="w-14 h-14"
                                                viewBox="0 0 14 14"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M0.21875 7.5625C0.0625 7.40625 0 7.21875 0 7C0 6.8125 0.0625 6.625 0.21875 6.46875L5.71875 1.21875C6.03125 0.9375 6.5 0.9375 6.78125 1.25C7.0625 1.53125 7.0625 2.03125 6.75 2.3125L2.59375 6.25H13.25C13.6562 6.25 14 6.59375 14 7C14 7.4375 13.6562 7.75 13.25 7.75H2.59375L6.75 11.7188C7.0625 12 7.0625 12.4688 6.78125 12.7812C6.5 13.0938 6.03125 13.0938 5.71875 12.8125L0.21875 7.5625Z"
                                                    fill="#1A1A1A"
                                                />
                                            </svg>
                                        </button>
                                        <p className="text-20">
                                            Ticket #{activeTicket.id.slice(0, 8)}
                                        </p>
                                        <p className="text-darwin-neutrals-600 text-13">
                                            Last updated at{' '}
                                            {moment(activeTicket.last_activity_at).format(
                                                "DD MMM'YY, hh:mm A",
                                            )}
                                        </p>
                                        <button onClick={onRefreshActions}>
                                            <svg
                                                className="w-14 h-12 fill-darwin-accent-bright-blue-800"
                                                viewBox="0 0 14 12"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path d="M13.0938 4.70312C13.0938 5.05859 12.8145 5.3125 12.4844 5.3125H9.64062H8.82812C8.47266 5.3125 8.21875 5.05859 8.21875 4.70312C8.21875 4.37305 8.47266 4.09375 8.82812 4.09375H9.64062H11.0117L9.69141 2.77344C8.95508 2.0625 7.99023 1.65625 7 1.65625C5.14648 1.65625 3.54688 2.79883 2.88672 4.39844C2.73438 4.70312 2.37891 4.83008 2.07422 4.70312C1.76953 4.57617 1.61719 4.2207 1.74414 3.91602C2.60742 1.88477 4.63867 0.4375 7 0.4375C8.32031 0.4375 9.58984 0.970703 10.5293 1.91016L11.875 3.25586V1.85938V1.04688C11.875 0.716797 12.1289 0.4375 12.4844 0.4375C12.8145 0.4375 13.0938 0.716797 13.0938 1.04688V4.70312ZM1.51562 6.9375H4.35938C4.68945 6.9375 4.96875 7.2168 4.96875 7.54688C4.96875 7.90234 4.68945 8.15625 4.35938 8.15625H2.96289L4.30859 9.50195C5.01953 10.2129 5.98438 10.5938 7 10.5938C8.82812 10.5938 10.4277 9.50195 11.0879 7.90234C11.2402 7.57227 11.5957 7.44531 11.9004 7.57227C12.2051 7.69922 12.3574 8.05469 12.2305 8.38477C11.3418 10.3906 9.33594 11.8125 7 11.8125C5.6543 11.8125 4.38477 11.3047 3.44531 10.3652L2.125 9.01953V10.3906C2.125 10.7461 1.8457 11 1.51562 11C1.16016 11 0.90625 10.7461 0.90625 10.3906V7.54688C0.90625 7.2168 1.16016 6.9375 1.51562 6.9375Z" />
                                            </svg>
                                        </button>
                                    </div>
                                    <div
                                        className="flex items-center space-x-4 px-8 py-4 rounded-4"
                                        style={{ color, background }}
                                    >
                                        {icon}
                                        <p className="text-13 font-700">{activeTicket.status}</p>
                                    </div>
                                </div>
                                <div className="flex-1 flex flex-col overflow-hidden space-y-8">
                                    <div className="p-16 space-y-16">
                                        <div className="flex items-start justify-between space-x-12">
                                            <div className="flex-1">
                                                <p className="font-700 text-16">
                                                    {activeTicket.name}
                                                </p>
                                            </div>
                                            <button
                                                className="font-700 text-darwin-accent-bright-blue-800"
                                                onClick={onRequestUpdate}
                                            >
                                                Request Update
                                            </button>
                                        </div>
                                        {!isFetchingActions && (
                                            <Fragment>
                                                <p>{description}</p>
                                                <div className="flex items-start justify-between space-x-8">
                                                    <div className="flex items-center space-x-8">
                                                        <div className="w-36 h-36 rounded-full bg-white flex items-center justify-center">
                                                            <svg
                                                                className="w-16 h-16 fill-darwin-accent-bright-blue-800"
                                                                viewBox="0 0 16 16"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path d="M15.4964 4.65116C15.4542 5.354 15.1585 6.0155 14.6304 6.5323L9.56121 11.4935C9.43448 11.6176 9.28663 11.7416 9.11766 11.845C7.95597 12.6098 6.37184 12.4651 5.37912 11.4935C4.76659 10.8941 4.44976 10.0465 4.53425 9.17829C4.55537 8.6615 4.99892 8.26873 5.52697 8.26873C6.07613 8.26873 6.51969 8.70284 6.51969 9.24031C6.51969 9.52972 6.39296 9.77778 6.20286 9.96382C6.26623 10.1292 6.37184 10.2946 6.51969 10.4186C6.77315 10.6667 7.13222 10.8114 7.49129 10.8114C7.72363 10.8114 7.93484 10.77 8.12494 10.6667C8.25167 10.6047 8.35728 10.522 8.46289 10.4186L10.9552 7.97933L9.92029 6.96641L8.44176 5.51938C8.1883 5.27132 7.82924 5.12661 7.47017 5.12661C7.1111 5.12661 6.75203 5.27132 6.49857 5.51938C6.32959 5.68475 6.20286 5.89147 6.1395 6.09819C6.37184 6.28424 6.54081 6.55297 6.54081 6.86305C6.54081 7.40052 6.09725 7.83463 5.54809 7.83463C5.04117 7.83463 4.59761 7.44186 4.55537 6.94574C4.3864 6.0155 4.6821 5.08527 5.37912 4.4031C5.92828 3.86563 6.66754 3.55556 7.47017 3.55556C8.25167 3.55556 9.01205 3.86563 9.56121 4.4031L11.0397 5.85013L12.0747 6.86305L13.511 5.45736C13.7856 5.18863 13.9123 4.85788 13.9123 4.48579C13.9123 4.15504 13.7856 3.84496 13.5532 3.61757C12.9407 2.95607 12.2014 2.43928 11.3777 2.06718C10.5117 1.69509 9.60346 1.48837 8.65298 1.48837C6.87876 1.48837 5.23126 2.17054 3.96396 3.39018C2.71778 4.60982 2.02076 6.24289 2.02076 7.97933C2.02076 9.71576 2.71778 11.3282 3.96396 12.5685C5.21014 13.7881 6.87876 14.4703 8.65298 14.4703C9.60346 14.4703 10.5117 14.2842 11.3777 13.8915C12.2014 13.5194 12.9407 13.0026 13.5532 12.3411C14.039 11.8036 14.0179 10.9974 13.511 10.4806L12.4549 9.44703L13.5743 8.35142L14.6304 9.38501C15.7499 10.4806 15.7921 12.2171 14.736 13.3747C13.9757 14.2016 13.0674 14.8424 12.0536 15.2972C10.9975 15.7726 9.85692 16 8.6741 16C7.57577 16 6.49857 15.7933 5.48472 15.3798C4.51313 14.9664 3.62601 14.3876 2.88675 13.6641C2.12637 12.9199 1.53496 12.0724 1.13365 11.1214C0.711217 10.1292 0.5 9.07493 0.5 8C0.5 6.92506 0.711217 5.8708 1.13365 4.87855C1.55609 3.92765 2.14749 3.05943 2.88675 2.33592C3.64713 1.59173 4.51313 1.01292 5.48472 0.620156C6.49857 0.206719 7.57577 0 8.6741 0C9.85692 0 10.9764 0.248061 12.0536 0.702842C13.0885 1.15762 13.9757 1.79845 14.736 2.62532C15.0529 2.97674 15.3063 3.41085 15.4119 3.86563C15.4753 4.05168 15.4964 4.36176 15.4964 4.65116Z" />
                                                            </svg>
                                                        </div>
                                                        <div>
                                                            <p className="text-11">Assigned to</p>
                                                            <p className="text-13 font-700">
                                                                {activeTicket.members.join(', ') ||
                                                                    'Eka Support'}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="flex items-center space-x-8">
                                                        <div className="w-36 h-36 rounded-full bg-white flex items-center justify-center">
                                                            <svg
                                                                className="w-16 h-16 fill-darwin-accent-bright-blue-800"
                                                                viewBox="0 0 16 16"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path d="M15.4964 4.65116C15.4542 5.354 15.1585 6.0155 14.6304 6.5323L9.56121 11.4935C9.43448 11.6176 9.28663 11.7416 9.11766 11.845C7.95597 12.6098 6.37184 12.4651 5.37912 11.4935C4.76659 10.8941 4.44976 10.0465 4.53425 9.17829C4.55537 8.6615 4.99892 8.26873 5.52697 8.26873C6.07613 8.26873 6.51969 8.70284 6.51969 9.24031C6.51969 9.52972 6.39296 9.77778 6.20286 9.96382C6.26623 10.1292 6.37184 10.2946 6.51969 10.4186C6.77315 10.6667 7.13222 10.8114 7.49129 10.8114C7.72363 10.8114 7.93484 10.77 8.12494 10.6667C8.25167 10.6047 8.35728 10.522 8.46289 10.4186L10.9552 7.97933L9.92029 6.96641L8.44176 5.51938C8.1883 5.27132 7.82924 5.12661 7.47017 5.12661C7.1111 5.12661 6.75203 5.27132 6.49857 5.51938C6.32959 5.68475 6.20286 5.89147 6.1395 6.09819C6.37184 6.28424 6.54081 6.55297 6.54081 6.86305C6.54081 7.40052 6.09725 7.83463 5.54809 7.83463C5.04117 7.83463 4.59761 7.44186 4.55537 6.94574C4.3864 6.0155 4.6821 5.08527 5.37912 4.4031C5.92828 3.86563 6.66754 3.55556 7.47017 3.55556C8.25167 3.55556 9.01205 3.86563 9.56121 4.4031L11.0397 5.85013L12.0747 6.86305L13.511 5.45736C13.7856 5.18863 13.9123 4.85788 13.9123 4.48579C13.9123 4.15504 13.7856 3.84496 13.5532 3.61757C12.9407 2.95607 12.2014 2.43928 11.3777 2.06718C10.5117 1.69509 9.60346 1.48837 8.65298 1.48837C6.87876 1.48837 5.23126 2.17054 3.96396 3.39018C2.71778 4.60982 2.02076 6.24289 2.02076 7.97933C2.02076 9.71576 2.71778 11.3282 3.96396 12.5685C5.21014 13.7881 6.87876 14.4703 8.65298 14.4703C9.60346 14.4703 10.5117 14.2842 11.3777 13.8915C12.2014 13.5194 12.9407 13.0026 13.5532 12.3411C14.039 11.8036 14.0179 10.9974 13.511 10.4806L12.4549 9.44703L13.5743 8.35142L14.6304 9.38501C15.7499 10.4806 15.7921 12.2171 14.736 13.3747C13.9757 14.2016 13.0674 14.8424 12.0536 15.2972C10.9975 15.7726 9.85692 16 8.6741 16C7.57577 16 6.49857 15.7933 5.48472 15.3798C4.51313 14.9664 3.62601 14.3876 2.88675 13.6641C2.12637 12.9199 1.53496 12.0724 1.13365 11.1214C0.711217 10.1292 0.5 9.07493 0.5 8C0.5 6.92506 0.711217 5.8708 1.13365 4.87855C1.55609 3.92765 2.14749 3.05943 2.88675 2.33592C3.64713 1.59173 4.51313 1.01292 5.48472 0.620156C6.49857 0.206719 7.57577 0 8.6741 0C9.85692 0 10.9764 0.248061 12.0536 0.702842C13.0885 1.15762 13.9757 1.79845 14.736 2.62532C15.0529 2.97674 15.3063 3.41085 15.4119 3.86563C15.4753 4.05168 15.4964 4.36176 15.4964 4.65116Z" />
                                                            </svg>
                                                        </div>
                                                        <div>
                                                            <p className="text-11">
                                                                Raised on{' '}
                                                                {moment(
                                                                    activeTicket.created_at,
                                                                ).format('llll')}
                                                            </p>
                                                            <p className="text-13 font-700">
                                                                by Eka Support
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Fragment>
                                        )}
                                    </div>
                                    {isFetchingActions ? (
                                        <div className="flex-1 flex items-center justify-center">
                                            <svg
                                                className="w-24 h-24 fill-darwin-accent-bright-blue-800 animate-spin"
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 512 512"
                                            >
                                                <path d="M96 256c0-26.5-21.5-48-48-48S0 229.5 0 256s21.5 48 48 48S96 282.5 96 256zM108.9 60.89c-26.5 0-48.01 21.49-48.01 47.99S82.39 156.9 108.9 156.9s47.99-21.51 47.99-48.01S135.4 60.89 108.9 60.89zM108.9 355.1c-26.5 0-48.01 21.51-48.01 48.01S82.39 451.1 108.9 451.1s47.99-21.49 47.99-47.99S135.4 355.1 108.9 355.1zM256 416c-26.5 0-48 21.5-48 48S229.5 512 256 512s48-21.5 48-48S282.5 416 256 416zM464 208C437.5 208 416 229.5 416 256s21.5 48 48 48S512 282.5 512 256S490.5 208 464 208zM403.1 355.1c-26.5 0-47.99 21.51-47.99 48.01S376.6 451.1 403.1 451.1s48.01-21.49 48.01-47.99S429.6 355.1 403.1 355.1zM256 0C229.5 0 208 21.5 208 48S229.5 96 256 96s48-21.5 48-48S282.5 0 256 0z"></path>
                                            </svg>
                                        </div>
                                    ) : (
                                        <div className="relative flex-1 flex flex-col mx-16 my-8 bg-white p-16 rounded-8 space-y-16 overflow-auto">
                                            <div className="space-y-8">
                                                <p className="font-700">
                                                    Attachments:{' '}
                                                    {activeTicket.attachments.length === 0 && '-'}
                                                </p>
                                                {activeTicket.attachments.length > 0 && (
                                                    <div>
                                                        {activeTicket.attachments.map(
                                                            (i, index) => (
                                                                <div>
                                                                    <Button
                                                                        type="link"
                                                                        href={i.url}
                                                                        target="_blank"
                                                                        className="text-13 p-0 space-x-5"
                                                                    >
                                                                        <span>{index + 1}. </span>
                                                                        <span>{i.name}</span>
                                                                    </Button>
                                                                </div>
                                                            ),
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                            <div className="space-y-12">
                                                <p className="font-700">
                                                    Latest updates: {actions.length === 0 && '-'}
                                                </p>
                                                {actions.length > 0 && (
                                                    <div className="flex-1 space-y-12 overflow-auto">
                                                        {actions.map((action) => (
                                                            <div className="flex items-start">
                                                                <p className="text-10 font-700 py-4 text-darwin-neutrals-600 min-w-144">
                                                                    {moment(
                                                                        action.created_at,
                                                                    ).format('llll')}
                                                                </p>
                                                                <p
                                                                    className="text-13 break-words"
                                                                    dangerouslySetInnerHTML={{
                                                                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                                                        // @ts-ignore
                                                                        __html: marked.parse(
                                                                            action.text,
                                                                        ),
                                                                    }}
                                                                ></p>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                    <div className="text-11 text-darwin-accent-bright-blue-800 flex items-center justify-center p-16 whitespace-nowrap space-x-12">
                                        <button
                                            className="flex items-center space-x-4"
                                            onClick={() => onFeedback('positive')}
                                        >
                                            <span>Helpful</span>
                                            <span>
                                                <svg
                                                    className="w-14 h-12 fill-darwin-accent-bright-blue-800"
                                                    viewBox="0 0 14 12"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path d="M8.70117 0.513672C9.69141 0.792969 10.25 1.80859 9.9707 2.77344L9.81836 3.28125C9.74219 3.56055 9.64062 3.83984 9.51367 4.09375H11.875C12.7637 4.09375 13.5 4.83008 13.5 5.71875C13.5 6.17578 13.2969 6.58203 13.0176 6.88672C13.0684 7.03906 13.0938 7.19141 13.0938 7.36914C13.0938 7.87695 12.8398 8.35938 12.4336 8.66406C12.459 8.76562 12.4844 8.86719 12.4844 8.99414C12.4844 9.50195 12.2305 9.95898 11.875 10.2637C11.8242 11.127 11.1133 11.8379 10.25 11.8379H7.76172C7.20312 11.8379 6.64453 11.6602 6.1875 11.3555L4.61328 10.3145C4.33398 10.1113 4.25781 9.73047 4.46094 9.45117C4.63867 9.17188 5.01953 9.0957 5.29883 9.29883L6.87305 10.3398C7.12695 10.5176 7.43164 10.5938 7.76172 10.5938H10.25C10.4531 10.5938 10.6562 10.416 10.6562 10.1875C10.6562 10.1621 10.6309 10.1113 10.6309 10.0859C10.5547 9.78125 10.707 9.47656 10.9863 9.34961C11.1387 9.29883 11.2656 9.14648 11.2656 8.96875C11.2656 8.89258 11.2148 8.79102 11.1641 8.74023C11.0371 8.5625 11.0117 8.33398 11.0879 8.13086C11.1387 7.92773 11.3164 7.80078 11.5449 7.75C11.7227 7.72461 11.875 7.54688 11.875 7.34375C11.875 7.24219 11.8242 7.16602 11.7734 7.08984C11.6211 6.9375 11.5703 6.73438 11.6211 6.53125C11.6719 6.32812 11.8242 6.17578 12.002 6.09961C12.1543 6.04883 12.2812 5.89648 12.2812 5.71875C12.2812 5.51562 12.0781 5.3125 11.875 5.3125H8.47266C8.24414 5.3125 8.04102 5.18555 7.93945 4.98242C7.83789 4.7793 7.83789 4.55078 7.96484 4.37305C8.26953 3.94141 8.49805 3.45898 8.65039 2.95117L8.80273 2.44336C8.87891 2.11328 8.70117 1.7832 8.37109 1.68164C8.04102 1.60547 7.71094 1.7832 7.60938 2.11328L7.48242 2.62109C7.33008 3.12891 7.07617 3.58594 6.7207 3.99219L5.40039 5.41406C5.17188 5.66797 4.79102 5.69336 4.53711 5.46484C4.30859 5.23633 4.2832 4.85547 4.51172 4.60156L5.80664 3.17969C6.03516 2.92578 6.21289 2.62109 6.31445 2.29102L6.44141 1.7832C6.7207 0.792969 7.73633 0.234375 8.70117 0.513672ZM1.3125 4.5H2.9375C3.36914 4.5 3.75 4.88086 3.75 5.3125V11C3.75 11.457 3.36914 11.8125 2.9375 11.8125H1.3125C0.855469 11.8125 0.5 11.457 0.5 11V5.3125C0.5 4.88086 0.855469 4.5 1.3125 4.5Z" />
                                                </svg>
                                            </span>
                                        </button>
                                        <FeedbackPopover onFeedback={onFeedback}>
                                            <button className="flex items-center space-x-4">
                                                <span>Not helpful</span>
                                                <span>
                                                    <svg
                                                        className="w-14 h-12 fill-darwin-accent-bright-blue-800"
                                                        viewBox="0 0 14 13"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path d="M8.70117 11.7617C7.73633 12.041 6.7207 11.457 6.44141 10.4922L6.31445 9.98438C6.21289 9.6543 6.03516 9.34961 5.80664 9.0957L4.51172 7.67383C4.2832 7.41992 4.30859 7.03906 4.53711 6.81055C4.79102 6.58203 5.17188 6.60742 5.40039 6.86133L6.7207 8.2832C7.07617 8.66406 7.33008 9.14648 7.48242 9.6543L7.60938 10.1621C7.71094 10.4922 8.04102 10.6699 8.37109 10.5938C8.70117 10.4922 8.87891 10.1621 8.80273 9.83203L8.65039 9.32422C8.49805 8.81641 8.26953 8.33398 7.96484 7.90234C7.83789 7.72461 7.83789 7.4707 7.93945 7.26758C8.04102 7.06445 8.24414 6.9375 8.47266 6.9375H11.875C12.0781 6.9375 12.2812 6.75977 12.2812 6.53125C12.2812 6.37891 12.1543 6.22656 12.002 6.15039C11.8242 6.09961 11.6719 5.92188 11.6211 5.74414C11.5703 5.54102 11.6211 5.33789 11.7734 5.18555C11.8242 5.10938 11.875 5.0332 11.875 4.90625C11.875 4.72852 11.7227 4.55078 11.5449 4.52539C11.3164 4.47461 11.1387 4.32227 11.0879 4.14453C11.0117 3.94141 11.0371 3.71289 11.1641 3.53516C11.2148 3.48438 11.2656 3.38281 11.2656 3.28125C11.2656 3.12891 11.1387 2.97656 10.9863 2.90039C10.707 2.79883 10.5547 2.49414 10.6309 2.18945C10.6309 2.13867 10.6562 2.11328 10.6562 2.0625C10.6562 1.85938 10.4531 1.65625 10.25 1.65625H7.76172C7.43164 1.65625 7.12695 1.75781 6.87305 1.93555L5.29883 2.97656C5.01953 3.17969 4.63867 3.10352 4.46094 2.79883C4.25781 2.51953 4.33398 2.16406 4.61328 1.96094L6.1875 0.919922C6.64453 0.615234 7.20312 0.4375 7.76172 0.4375H10.25C11.1133 0.4375 11.8242 1.14844 11.875 2.01172C12.2305 2.31641 12.4844 2.77344 12.4844 3.28125C12.4844 3.4082 12.459 3.50977 12.4336 3.61133C12.8398 3.91602 13.0938 4.37305 13.0938 4.90625C13.0938 5.08398 13.0684 5.23633 13.0176 5.38867C13.2969 5.69336 13.5 6.09961 13.5 6.53125C13.5 7.44531 12.7637 8.15625 11.875 8.15625H9.51367C9.64062 8.43555 9.74219 8.71484 9.81836 8.99414L9.9707 9.50195C10.25 10.4668 9.69141 11.4824 8.70117 11.7617ZM1.3125 9.375C0.855469 9.375 0.5 9.01953 0.5 8.5625V2.875C0.5 2.44336 0.855469 2.0625 1.3125 2.0625H2.9375C3.36914 2.0625 3.75 2.44336 3.75 2.875V8.5625C3.75 9.01953 3.36914 9.375 2.9375 9.375H1.3125Z" />
                                                    </svg>
                                                </span>
                                            </button>
                                        </FeedbackPopover>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div
                                className="w-full h-full flex flex-col bg-darwin-neutrals-50 overflow-hidden"
                                style={{ color: '#1A1A1A' }}
                            >
                                <div className="px-16 py-12 flex items-center justify-between space-x-8 bg-white border-b border-darwin-neutral_new-200">
                                    <div className="flex items-center space-x-8">
                                        <p className="text-20">My Support Tickets</p>
                                        <p className="text-darwin-neutrals-600 text-13 relative top-1">
                                            Last updated at {moment(lastUpdated).format('hh:mm A')}
                                        </p>
                                        <button onClick={onRefreshTickets}>
                                            <svg
                                                className="w-14 h-12 fill-darwin-accent-bright-blue-800"
                                                viewBox="0 0 14 12"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path d="M13.0938 4.70312C13.0938 5.05859 12.8145 5.3125 12.4844 5.3125H9.64062H8.82812C8.47266 5.3125 8.21875 5.05859 8.21875 4.70312C8.21875 4.37305 8.47266 4.09375 8.82812 4.09375H9.64062H11.0117L9.69141 2.77344C8.95508 2.0625 7.99023 1.65625 7 1.65625C5.14648 1.65625 3.54688 2.79883 2.88672 4.39844C2.73438 4.70312 2.37891 4.83008 2.07422 4.70312C1.76953 4.57617 1.61719 4.2207 1.74414 3.91602C2.60742 1.88477 4.63867 0.4375 7 0.4375C8.32031 0.4375 9.58984 0.970703 10.5293 1.91016L11.875 3.25586V1.85938V1.04688C11.875 0.716797 12.1289 0.4375 12.4844 0.4375C12.8145 0.4375 13.0938 0.716797 13.0938 1.04688V4.70312ZM1.51562 6.9375H4.35938C4.68945 6.9375 4.96875 7.2168 4.96875 7.54688C4.96875 7.90234 4.68945 8.15625 4.35938 8.15625H2.96289L4.30859 9.50195C5.01953 10.2129 5.98438 10.5938 7 10.5938C8.82812 10.5938 10.4277 9.50195 11.0879 7.90234C11.2402 7.57227 11.5957 7.44531 11.9004 7.57227C12.2051 7.69922 12.3574 8.05469 12.2305 8.38477C11.3418 10.3906 9.33594 11.8125 7 11.8125C5.6543 11.8125 4.38477 11.3047 3.44531 10.3652L2.125 9.01953V10.3906C2.125 10.7461 1.8457 11 1.51562 11C1.16016 11 0.90625 10.7461 0.90625 10.3906V7.54688C0.90625 7.2168 1.16016 6.9375 1.51562 6.9375Z" />
                                            </svg>
                                        </button>
                                    </div>
                                    <button onClick={closeMe}>
                                        <svg
                                            className="w-14 h-14"
                                            viewBox="0 0 10 9"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M8.88477 1.60352L5.83789 4.65039L8.85938 7.67188C9.11328 7.90039 9.11328 8.28125 8.85938 8.50977C8.63086 8.76367 8.25 8.76367 8.02148 8.50977L4.97461 5.48828L1.95312 8.50977C1.72461 8.76367 1.34375 8.76367 1.11523 8.50977C0.861328 8.28125 0.861328 7.90039 1.11523 7.64648L4.13672 4.625L1.11523 1.60352C0.861328 1.375 0.861328 0.994141 1.11523 0.740234C1.34375 0.511719 1.72461 0.511719 1.97852 0.740234L5 3.78711L8.02148 0.765625C8.25 0.511719 8.63086 0.511719 8.88477 0.765625C9.11328 0.994141 9.11328 1.375 8.88477 1.60352Z"
                                                fill="#1A1A1A"
                                            />
                                        </svg>
                                    </button>
                                </div>
                                {(isFetchingTickets || statusFilters.length > 0) && (
                                    <div className="flex items-center space-x-8 p-16 overflow-auto whitespace-nowrap">
                                        {isFetchingTickets ? (
                                            <Fragment>
                                                <button className="border border-darwin-neutral_new-200 h-40 w-120 shimmer rounded-8"></button>
                                                <button className="border border-darwin-neutral_new-200 h-40 w-120 shimmer rounded-8"></button>
                                                <button className="border border-darwin-neutral_new-200 h-40 w-120 shimmer rounded-8"></button>
                                            </Fragment>
                                        ) : (
                                            statusFilters.map((i) => (
                                                <button
                                                    className={`flex items-center space-x-8 border px-12 rounded-8 text-13 py-9 bg-white ${
                                                        statusFiltersSet.has(i.status)
                                                            ? 'border-darwin-accent-bright-blue-800 text-darwin-accent-bright-blue-800 bg-darwin-accent-bright-blue-100 font-700'
                                                            : 'border-darwin-neutral_new-200'
                                                    }`}
                                                    onClick={() => toggleStatusFilters(i.status)}
                                                >
                                                    <p>
                                                        {i.label} ({i.count})
                                                    </p>
                                                    {statusFiltersSet.has(i.status) && (
                                                        <p>
                                                            <svg
                                                                className="w-12 h-12"
                                                                viewBox="0 0 12 12"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path
                                                                    d="M10.7812 2.28125L7.03125 6.03125L10.75 9.75C11.0625 10.0312 11.0625 10.5 10.75 10.7812C10.4688 11.0938 10 11.0938 9.71875 10.7812L5.96875 7.0625L2.25 10.7812C1.96875 11.0938 1.5 11.0938 1.21875 10.7812C0.90625 10.5 0.90625 10.0312 1.21875 9.71875L4.9375 6L1.21875 2.28125C0.90625 2 0.90625 1.53125 1.21875 1.21875C1.5 0.9375 1.96875 0.9375 2.28125 1.21875L6 4.96875L9.71875 1.25C10 0.9375 10.4688 0.9375 10.7812 1.25C11.0625 1.53125 11.0625 2 10.7812 2.28125Z"
                                                                    fill="#1A1A1A"
                                                                />
                                                            </svg>
                                                        </p>
                                                    )}
                                                </button>
                                            ))
                                        )}
                                        {statusFiltersSet.size > 0 && (
                                            <p
                                                className="text-13 font-700 text-darwin-accent-bright-blue-800 underline cursor-pointer"
                                                onClick={clearFilters}
                                            >
                                                Clear filters
                                            </p>
                                        )}
                                    </div>
                                )}
                                <div className="flex-1 overflow-auto">
                                    {isFetchingTickets ? (
                                        <div className="h-full flex items-center justify-center">
                                            <svg
                                                className="w-24 h-24 fill-darwin-accent-bright-blue-800 animate-spin"
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 512 512"
                                            >
                                                <path d="M96 256c0-26.5-21.5-48-48-48S0 229.5 0 256s21.5 48 48 48S96 282.5 96 256zM108.9 60.89c-26.5 0-48.01 21.49-48.01 47.99S82.39 156.9 108.9 156.9s47.99-21.51 47.99-48.01S135.4 60.89 108.9 60.89zM108.9 355.1c-26.5 0-48.01 21.51-48.01 48.01S82.39 451.1 108.9 451.1s47.99-21.49 47.99-47.99S135.4 355.1 108.9 355.1zM256 416c-26.5 0-48 21.5-48 48S229.5 512 256 512s48-21.5 48-48S282.5 416 256 416zM464 208C437.5 208 416 229.5 416 256s21.5 48 48 48S512 282.5 512 256S490.5 208 464 208zM403.1 355.1c-26.5 0-47.99 21.51-47.99 48.01S376.6 451.1 403.1 451.1s48.01-21.49 48.01-47.99S429.6 355.1 403.1 355.1zM256 0C229.5 0 208 21.5 208 48S229.5 96 256 96s48-21.5 48-48S282.5 0 256 0z"></path>
                                            </svg>
                                        </div>
                                    ) : tickets.length === 0 ? (
                                        <div className="h-full flex items-center justify-center">
                                            <p className="font-700">
                                                No tickets has been raised yet
                                            </p>
                                        </div>
                                    ) : (
                                        tickets.map((ticket, index) => {
                                            const {
                                                id,
                                                name,
                                                status,
                                                created_at,
                                                last_activity_at,
                                            } = ticket;
                                            const ticketId = id.slice(0, 8);
                                            const createdAt = moment(created_at).format('llll');
                                            const lastActivityAt = moment(last_activity_at).format(
                                                'llll',
                                            );
                                            const { color, background, icon } = colorObject[status];

                                            return (
                                                <div
                                                    className={`p-16 border-t ${
                                                        index + 1 === tickets.length
                                                            ? 'border-b mb-100'
                                                            : ''
                                                    } border-darwin-neutral_new-200 bg-white space-y-8 cursor-pointer hover:bg-darwin-neutrals-50`}
                                                    onClick={() => toggleActiveTicket(ticket)}
                                                >
                                                    <div className="flex items-start justify-between space-x-8">
                                                        <div className="space-y-4">
                                                            <p className="font-700">{name}</p>
                                                            <p className="text-12 text-darwin-neutrals-600">
                                                                Ticket #{ticketId} | {createdAt}
                                                            </p>
                                                        </div>
                                                        <div
                                                            className="flex items-center space-x-4 px-8 py-4 rounded-4 whitespace-nowrap"
                                                            style={{ color, background }}
                                                        >
                                                            {icon}
                                                            <p className="text-13 font-700">
                                                                {status}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="space-y-5">
                                                        <p className="text-11 text-darwin-neutrals-600">
                                                            <span className="font-700">
                                                                Last activity at:{' '}
                                                            </span>
                                                            {lastActivityAt}
                                                        </p>
                                                    </div>
                                                </div>
                                            );
                                        })
                                    )}
                                </div>
                                <div className="text-13 font-700 px-16 py-12 flex items-center justify-between space-x-8 bg-white border-t border-darwin-neutral_new-200">
                                    <button
                                        className="px-11 py-9 border border-darwin-accent-bright-blue-800 text-darwin-accent-bright-blue-800 rounded-8"
                                        onClick={onConnectWithSuccessManager}
                                    >
                                        Connect with your success manager
                                    </button>
                                    <button
                                        className="px-12 py-10 bg-darwin-accent-bright-blue-800 text-white rounded-8"
                                        onClick={onRaiseNewTicket}
                                    >
                                        Raise new ticket
                                    </button>
                                </div>
                            </div>
                        )}
                    </SlideFromRightWrapper>
                </Hotkeys>
            </AnimatePresence>
        );
    }
}

export default connect()(AllSupportTickets);
